import React, { Component } from "react";
import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import AccessoryFinder from "../Pages/AccessoryFinder/AccessoryFinder";
import Login from "../Pages/Login/Login";
import Privacy from "../Pages/Privacy/Privacy";
import AdminHome from "../Pages/AdminHome/AdminHome";
import UserManagement from "../Pages/UserManagement/UserManagement";
import ModelManagement from "../Pages/ModelManagement/ModelManagement";
import AccessoriesManagement from "../Pages/AccessoriesManagement/AccessoriesManagement";

import UpdateProfile from "../Pages/UpdateProfile/UpdateProfile";
import ChangePassword from "../Pages/ChangePassword/ChangePassword";

import PrivateRoute from "../_components/PrivateRoute";
import PageNotFound from "../_components/ErrorPages/PageNotFound/PageNotFound";
import Layout from "../_components/Layout/Layout";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");

class App extends Component {
  componentDidMount() {
    if (!window.location.href.includes("Privacy")) {
      const oneTrustElement = document.getElementById(
        "otnotice-992457b6-7514-439d-8f42-847cdbdd8326",
      );

      oneTrustElement.style.display = "none";
    }
  }

  render() {
    return (
      <BrowserRouter basename={baseUrl}>
        <Layout>
          <Switch>
            <Route path="/" exact component={AccessoryFinder} />
            <Route path="/accessory-finder" exact component={AccessoryFinder} />
            <Route path="/admin-login" exact component={Login} />
            <Route path="/privacy" exact component={Privacy} />
            <PrivateRoute exact path="/admin-home" component={AdminHome} />
            <PrivateRoute
              exact
              path="/user-management"
              component={UserManagement}
            />
            <PrivateRoute
              exact
              path="/model-management"
              component={ModelManagement}
            />
            <PrivateRoute
              exact
              path="/accessories-management"
              component={AccessoriesManagement}
            />
            <PrivateRoute
              exact
              path="/account/update-profile"
              component={UpdateProfile}
            />
            <PrivateRoute
              exact
              path="/account/change-password"
              component={ChangePassword}
            />
            <Route path="*" component={PageNotFound} />
          </Switch>
        </Layout>
      </BrowserRouter>
    );
  }
}

export default App;
